import asyncComponent from '../../components/AsyncComponent';

const ClientList = asyncComponent(() => import('../../containers/Partners/ClientList'));

export default ClientList;
